import {
  bindTrackingEvents,
  isExperimentEnabled,
  trackEvent,
  TrackingEvent
} from 'views/assets/scripts/optimizely'
import { subscribe } from 'shared/store'

import { PDP_XSELL_TOP } from 'shared/experiments/consts'
import { INIT_XSELL_TOP_SLIDER } from 'shared/store/ducks/events'

const A2C_CLICK_EVENT_NAME = 'PDP XSELL SLIDER ON TOP - Add to cart click'
const VARIANT_CLICK_EVENT_NAME = 'PDP XSELL SLIDER ON TOP - Variant click'
const SLIDER_PRODUCT_CLICK_EVENT_NAME =
  'PDP XSELL SLIDER ON TOP - Click on product in slider'
const SLIDER_NAV_CLICK_EVENT_NAME =
  'PDP XSELL SLIDER ON TOP - Click on slider arrow'

const PDP_TRACKING_DEFS: TrackingEvent[] = [
  {
    selector: '[data-clientside-hook~="add2CartForm"]',
    event: 'submit',
    trackingEvent: A2C_CLICK_EVENT_NAME
  }
]

const SLIDER_TRACKING_DEFS: TrackingEvent[] = [
  {
    selector: '.e-ProductSliderItem',
    event: 'click',
    trackingEvent: SLIDER_PRODUCT_CLICK_EVENT_NAME
  },
  {
    selector: '.e-SliderHorizontal .o-SliderHorizontal__nav',
    event: 'click',
    trackingEvent: SLIDER_NAV_CLICK_EVENT_NAME
  }
]

export default () => {
  if (!isExperimentEnabled(PDP_XSELL_TOP)) {
    return
  }

  bindTrackingEvents(PDP_TRACKING_DEFS)
  subscribe.after(INIT_XSELL_TOP_SLIDER, () =>
    requestAnimationFrame(() => bindTrackingEvents(SLIDER_TRACKING_DEFS))
  )

  document.addEventListener(
    'click',
    ({ target }: Event & { target: HTMLElement }) => {
      const variantLink = target?.closest(
        '[data-clientside-hook~="productVariant__link"]'
      )

      if (variantLink) {
        trackEvent(VARIANT_CLICK_EVENT_NAME)
      }
    }
  )
}
